import RankingSection from './RankingSection';

export default RankingSection;
